import React from "react";

export default function PlayIcon({ customClass = "" }) {
  return (
    <span className="absolute top-0 w-full h-full flex items-center justify-center">
      <svg
        viewBox="0 0 48 48"
        height="24"
        width="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`block lg:hidden ${customClass}`}
      >
        <circle cx="24" cy="24" r="23.5" fill="#fff" stroke="#1F2022" />
        <path d="m32.004 24-12 6.928V17.072l12 6.928Z" fill="#1F2022" />
      </svg>

      <svg
        viewBox="0 0 48 48"
        height="48"
        width="48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`hidden lg:block ${customClass}`}
      >
        <circle cx="24" cy="24" r="23.5" fill="#fff" stroke="#1F2022" />
        <path d="m32.004 24-12 6.928V17.072l12 6.928Z" fill="#1F2022" />
      </svg>
    </span>
  );
}
